/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.pageSize = 5;

//###############################################################
// Wordcloud
//###############################################################

const WORDCLOUD_COLORS = [
  '#004F99BB',
  '#004F99CC',
  '#004F99DD',
  '#004F99E0',
  '#004F99EE',
  '#004F99F0',
  '#004F99',
  '#004280',
  '#003566',
  '#00284d',
  '#001a33'
];

root.initWordClouds = function(el) {
  if (el === undefined) {
    return $('.word-cloud:visible').each(function(index) {
      return initWordCloud($(this));
    });
  } else {
    return el.find('.word-cloud:visible').each(function(index) {
      return initWordCloud($(this));
    });
  }
};

var initWordCloud = function(div) {
  var resizeTimer;
  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => createWordCloud(div), 150);
  });
  return createWordCloud(div);
};

var createWordCloud = function(div) {
  div.empty();
  const divWidth = div.innerWidth();
  wordCloud = WordCloud(div[0], {
    list: div.data('word-counts'),
    shape: 'square',
    gridSize: 25,
    shuffle: false,
    shrinkToFit: true,
    minSize: 10,
    drawOutOfBound: false,
    rotateRatio: 0,
    backgroundColor: 'transparent',
    color(word, weight, fontSize, distance, theta) { return WORDCLOUD_COLORS[Math.floor(weight / 10)]; },
    weightFactor: divWidth > 920 ?
                    size => Math.pow(size, 0.5) * 10
                  : divWidth > 640 ?
                    size => Math.pow(size, 0.5) * 8
                  :
                    size => Math.pow(size, 0.5) * 6,
    click(item, dimension, event) { return $.ajax(item[2], {headers: { Accept: 'application/javascript; charset=utf-8' }}); }
  }
  );
  wordCloudDiv = $(div)

  if (wordCloudDiv) {
    div[0].addEventListener('wordcloudstop', function() {
      $(wordCloudDiv).find('span').each(function() {
        const span = this;
        const word = span.textContent.trim();
        span.setAttribute('role', 'button');
        span.setAttribute('tabindex', '0');
        span.setAttribute('aria-label', `Filter by: ${word}`);

        // Mirror click behavior on keyboard activation
        span.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            span.click();
          }
        });
      });
    }, { once: true });
  };

  return wordCloud;
};

//###############################################################
// Text responses
//###############################################################

const textResponsesModeClicked = function(event) {
  const el = event.target;
  const top = $(el).parents('.text-summary');

  top.find('.mode-link').removeClass('is-active');
  top.find('.mode-content').hide();

  $(el).parents('.mode-link').addClass('is-active');
  const targetId = $(el).data('target');
  const tabContent = top.find(`#${targetId}`);
  return tabContent.show();
};


const initTextResponses = function(questionId) {
  $(`#text-summary-${questionId} .mode-link a`).click(event => textResponsesModeClicked(event));
  const list = $(`#text-responses-${questionId}`);
  list.foundation();

  return setTimeout(() => updateLinks(questionId));
};

root.initTextResponses = function(el) {
  if (typeof el === 'string') {
    return initTextResponses(el);
  } else if (el === undefined) {
    return $('.text-responses').each(function(index) {
      return initTextResponses($(this).data('question-id'));
    });
  } else {
    return initTextResponses(el.attr('id'));
  }
};

var updateLinks = function(questionId) {
  const list = $(`#text-responses-${questionId}`);

  list.data("visible", list.find(".text-response:visible").length);
  list.data("loaded", list.find(".text-response").length);

  const total = list.data("total");
  const visible = list.data("visible");

  const remaining = total - visible;

  list.find(".next-text-responses").toggle((total > visible) && (remaining > pageSize));
  list.find(".all-text-responses").toggle(total > visible);
  list.find(".hide-text-responses").toggle((total > pageSize) && (visible > pageSize));

  $("#next-text-responses-count-" + questionId).html(Math.min(pageSize, remaining));
  $("#all-text-responses-count-" + questionId).html(remaining);

  const sticky = list.find('[data-sticky]');
  if (sticky.length) { return sticky.foundation('_calc', true); }
};

let waitingForResponses = false;

root.showOtherResponses = function(questionId) {
  const otherResponses = $(`#other-text-responses-${questionId}`);
  if (!otherResponses.length) { return; }
  otherResponses.removeClass('hidden');
  const wordClouds = $(`#text-summary-${questionId} .word-cloud`);
  if (wordClouds.length && (wordClouds.first()[0] != null)) {
    initWordCloud(wordClouds.first());
  }
  $(`#show-other-responses-${questionId}`).toggle();
  return $(`#hide-other-responses-${questionId}`).toggle();
};

root.hideOtherResponses = function(questionId) {
  const otherResponses = $(`#other-text-responses-${questionId}`);
  otherResponses.addClass('hidden');
  $(`#show-other-responses-${questionId}`).toggle();
  return $(`#hide-other-responses-${questionId}`).toggle();
};

root.showNextResponses = function(questionId, doNotLoadMore) {
  const list = $(`#text-responses-${questionId}`);

  const loaded = list.data("loaded");
  const total = list.data("total");
  const visible = list.data("visible");
  const baseUrl = list.data("base-url");

  if (!doNotLoadMore && (total > loaded) && (Math.max(total, visible + (2 * pageSize)) > loaded)) {
    // if there are not enough responses (next page + 1 extra page), load more
    if (waitingForResponses) { return; }
    waitingForResponses = true;
    $.get(`${baseUrl}&skip=${loaded}&count=${pageSize}`, function(data) {
      waitingForResponses = false;
      list.find(".text-response:last").after(data);
      if ((visible + pageSize) > loaded) {
        return showNextResponses(questionId, true);
      } else {
        return updateLinks(questionId);
      }
    });
  }

  const responses = list.find(".text-response.hidden").slice(0, pageSize);
  responses.removeClass('hidden');

  return updateLinks(questionId);
};

root.showAllResponses = function(questionId, loadOnly) {
  const list = $(`#text-responses-${questionId}`);

  const loaded = list.data("loaded");
  const total = list.data("total");
  const visible = list.data("visible");
  const baseUrl = list.data("base-url");

  if (total > loaded) {
    // if there are not enough responses, load more
    if (waitingForResponses) { return; }
    waitingForResponses = true;
    return $.get(`${baseUrl}&skip=${loaded}`, function(data) {
      waitingForResponses = false;
      list.find(".text-response:last").after(data);
      if (!loadOnly) { list.find(".text-response:hidden").removeClass('hidden'); }
      return updateLinks(questionId);
    });
  } else {
    if (!loadOnly) { list.find(".text-response:hidden").removeClass('hidden'); }
    return updateLinks(questionId);
  }
};

root.hideResponses = function(questionId) {
  const list = $(`#text-responses-${questionId}`);

  const responses = list.find(".text-response:visible").slice(pageSize);
  responses.addClass('hidden');

  scrollToElement(list);
  return updateLinks(questionId);
};

root.toggleUncensoredText = function(text_response_id, show) {
  const $response = $(text_response_id);
  $response.toggleClass('censored', !show);
  return $response.toggleClass('uncensored', show);
};

let loadingAllResponses = false;

const loadAllResponses = function() {
  if (loadingAllResponses) { return; }
  loadingAllResponses = true;
  return $('.text-responses').each(function(index) {
    return root.showAllResponses($(this).data('question-id'), true);
  });
};

window.onbeforeprint = loadAllResponses;
window.matchMedia('print').addListener(function(mql) { if (mql.matches) { return loadAllResponses(); } });

